import Vue from "vue";
import vueThis from '@/main'


/**
 * 显示隐藏的自定义指令
 */
Vue.directive('permit', {
  bind: function (el, binding) {
    // console.log(el, binding);
    if (hasPower(binding)) return;
    if (binding.arg === 'tab') {
      window.setTimeout(() => {
        const id = el.getAttribute('aria-labelledby');
        el = document.querySelector(`#${id}`);
        setAttr(el, 'display');
      }, 17)
      return;
    }
    setAttr(el, 'display')
  }
})


/**
 * 禁用的自定义指令
 */
Vue.directive('disabled', {
  bind: function (el, binding) {
    if (!hasPower(binding)) {
      setAttr(el, 'disabled')
    }
  }
})

/**
 * 判断是否有权限
 * @param {*} binding 
 */
function hasPower(binding) {
  let permissions;
  if (vueThis.$store.getters['accountInfo/permissions']) {
    permissions = vueThis.$store.getters['accountInfo/permissions']
  } else {
    permissions = []
  }
  let flag = false;
  if (Object.prototype.toString.call(binding.value) == '[object Array]') {
    binding.value.forEach((item) => {
      if (permissions.indexOf(item) != -1) {
        flag = true
      }
    })
  } else {
    if (permissions.indexOf(binding.value) != -1) {
      flag = true
    }
  }
  return flag
}

function setAttr(el, type) {
  if (type == 'display') {
    el.style.display = 'none'
  } else {
    el.setAttribute('disabled', 'true')
  }
}

// //checkboxGroup的权限
// Vue.directive('checkBoxPermit', {
// 	bind: function (el, binding, vNode) {
// 		console.log(el, binding, vNode);
// 		console.log(el.dataset);
// 		// let permissions;
// 		// if (vueThis.$store.getters['accountInfo/account'].permissions) {
// 		// 	permissions = vueThis.$store.getters['accountInfo/account'].permissions
// 		// } else {
// 		// 	permissions = []
// 		// }
// 		// let valueArr = []
// 		// binding.value.forEach((item, index) => {
// 		// 	if (permissions.indexOf(item) == -1) {
// 		// 		// el.style.display = 'none'
// 		// 		valueArr.push(index + 1)
// 		// 	}
// 		// })
// 		// 	vNode.componentInstance.$options.propsData.disabledArr = valueArr;
// 		// console.log(vNode.componentInstance.$options.propsData);
// 		// vNode.componentOptions.propsData.disabledArr=valueArr;
// 		// console.log(vNode.componentOptions.propsData.disabledArr);
// 	},
// 	inserted: function (el,binding,vNode) {
// 		console.log(el.dataset,binding);
// 		console.log(vNode.componentInstance.$children[0].$el.dataset);

// 	}
// })